/* eslint-disable @typescript-eslint/no-explicit-any */
import { isNumber } from "./isNumber";
import { isString } from "./isString";

/**
 * Checks if a given character is a digit (0-9)
 * @param char - The character to check
 * @returns boolean - True if the character is a digit, false otherwise
 */
export function isDigit(char: any): boolean {
  return (isString(char) || isNumber(char)) && /^[0-9]$/.test(char.toString());
}
